import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { UserChangeReport } from './UserChangeReport';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class UserChangeReportMaterial extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   userChangeReportMaterialId: number;
   userChangeReportId: number;
   materialId: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   material: Material;
   userChangeReport: UserChangeReport;
}

